import React, { FC } from 'react'
import { Flex } from 'components/Box'
import Button from './Button'
import Spinner from '../Spinner'

interface LoadMoreButtonProps {
  onClick: () => void
  loading: boolean
}

export const LoadMoreButton: FC<LoadMoreButtonProps> = ({
  loading,
  onClick,
}) => (
  <Flex mt={4} justifyContent="center">
    <Button
      small
      disabled={loading}
      width="100px"
      onClick={onClick}
      variant="secondary">
      {loading ? <Spinner.Flex primary /> : 'Load More'}
    </Button>
  </Flex>
)
